import { formState } from "../../modules/form/FormState";
import { getInputSelect, getRecommenderProjects, nextPrev } from "../../pages/que-estas-buscando";
import { hideModal, showModal } from "../constants/functions/modalFunctions";
class PreregistroService {
    constructor(formState) {
        this.formState = formState;
    }
    sendLead(formData) {
        fetch('/ev-service/preregistro', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        }).then(response => response.json())
            .then(response => {
            var _a, _b, _c, _d;
            if (formData.contextPath == "que-estas-buscando/" && formData.origen != "Feria pop up") {
                (_a = document.getElementById("content-steps")) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
                const visHouseType = document.getElementById('visHouseType');
                const noVisHouseType = document.getElementById('noVisHouseType');
                const normalizeBuilderId = (value) => !value || value === 'all' ? 'all' : value.replace('builder', '');
                const cityID = normalizeBuilderId(getInputSelect('.js-builder-city-list', true));
                const zoneID = normalizeBuilderId(getInputSelect('.js-builder-zone-list', true));
                const sectorID = normalizeBuilderId(getInputSelect('.js-builder-sector-list', true));
                getRecommenderProjects(cityID, zoneID, sectorID, [formData.budget, formData.max_budget], [visHouseType, noVisHouseType]);
                showModal('modalSendWizard');
                setTimeout(() => hideModal('modalSendWizard'), 2000);
                nextPrev(1);
                (_b = document.querySelector('.content-buttons')) === null || _b === void 0 ? void 0 : _b.classList.remove('buttons-principal');
            }
            else {
                const nameForm = this.formState.manageState('formName');
                const form = document.querySelector(nameForm);
                if (formData.origen === 'Blog - Cesantías') {
                    triggerDownload("https://www.estrenarvivienda.com/sites/default/files/2026-02/modelo_carta_cesantias_2026.docx");
                }
                if (formData.origen === 'Blog - Prima') {
                    triggerDownload("https://www.estrenarvivienda.com/sites/default/files/2026-07/Plantilla%20Plan%20de%20pago%20-%20Estrenar%20Vivienda.xlsx");
                }
                if (formData.origen === 'Blog' || formData.origen === 'Blog - Cesantías' || formData.origen === 'Blog - Prima') {
                    sessionStorage.setItem('sent-form-blog', 'true');
                }
                (_c = form.querySelector('.load-send-form')) === null || _c === void 0 ? void 0 : _c.classList.remove("d-flex");
                (_d = form.querySelector('.js-confirmation-mess')) === null || _d === void 0 ? void 0 : _d.classList.add("d-flex");
                if (formData.contextReference == 'Feria') {
                    window.localStorage.setItem('fairFormSent', "true");
                    // setTimeout(() => {
                    //     hideModal('modalFair');
                    // }, 1500);
                }
            }
        });
    }
}
export function triggerDownload(url) {
    const link = document.createElement('a');
    link.href = url;
    link.download = '';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    link.remove();
}
export { PreregistroService };
export const serviceFormPreregistro = new PreregistroService(formState);
